import type { CuratedVideo } from "@/lib/gmat-resources";
import { cn } from "@/lib/cn";
import { YouTubeEmbed, YouTubeEmbedFooter } from "./YouTubeEmbed";

interface VideoCardProps extends CuratedVideo {
  /** First card on page can load iframe immediately; others click-to-play. */
  eager?: boolean;
  compact?: boolean;
}

export function VideoCard({
  title,
  channel,
  channelUrl,
  youtubeId,
  duration,
  tag,
  eager = false,
  compact = false,
}: VideoCardProps) {
  return (
    <article
      className={cn(
        "flex flex-col overflow-hidden rounded-2xl border border-border bg-card text-left",
        "transition-all hover:-translate-y-0.5 hover:shadow-lg hover:shadow-foreground/5",
        compact && "max-w-md",
      )}
    >
      <YouTubeEmbed
        videoId={youtubeId}
        title={title}
        lazy={!eager}
        className="rounded-t-2xl"
      />
      <div className="space-y-2 p-4">
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <span className="font-medium text-foreground">{channel}</span>
          <span>·</span>
          <span>{tag}</span>
          {duration && (
            <>
              <span>·</span>
              <span className="font-mono">{duration}</span>
            </>
          )}
        </div>
        <h3 className="text-sm font-medium leading-snug">{title}</h3>
        <YouTubeEmbedFooter videoId={youtubeId} channel={channel} channelUrl={channelUrl} />
      </div>
    </article>
  );
}
